// src/App.jsx
import React, { useState } from 'react';
import DateTimePicker from './DateTimePicker';
import MultiSelectWidget from './MultiSelectWidget';
import ChartWidget from './ChartWidget';
import DocumentUploadWidget from './DocumentUploadWidget';
import NotificationWidget from './NotificationWidget';
import AIImageWidget from './AIImageWidget';
import { format } from 'date-fns';
import { Calendar } from 'lucide-react';

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const [finalDate, setFinalDate] = useState(null);

  const handleSet = (date) => {
    // Requirement: "Applies the selection without closing the widget"
    setFinalDate(date);
    console.log("Date Saved:", date);
    // alert(`Date Applied: ${format(date, 'yyyy-MM-dd hh:mm a')}`);
  };

  const handleCancel = () => {
    // Requirement: "Cancels selection and closes the widget"
    setIsOpen(false);
  };

  return (
    <div className="min-h-screen bg-slate-200 flex flex-col items-center justify-center p-4 md:p-10">
      <h1 className="text-3xl font-bold text-slate-800 mb-10">React Widgets Demo</h1>

      <div className="flex flex-col lg:flex-row gap-8 w-full max-w-6xl items-start justify-center">

        {/* Date Time Picker Section */}
        <div className="flex-1 w-full flex flex-col items-center">
          <div className="bg-white p-6 rounded-xl shadow-md w-full max-w-md">
            <h2 className="text-xl font-semibold text-slate-700 mb-4">Date Time Picker</h2>
            <div className="mb-4">
              <label className="block text-slate-700 text-sm font-bold mb-2">
                Select Date & Time
              </label>

              <div className="relative">
                <div
                  onClick={() => setIsOpen(true)}
                  className="flex items-center justify-between bg-white border border-slate-300 text-slate-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 w-full p-2.5 cursor-pointer hover:border-slate-400 transition-colors"
                >
                  <span className={!finalDate ? 'text-slate-400' : ''}>
                    {finalDate ? format(finalDate, 'MMMM d, yyyy - h:mm a') : 'Select a date...'}
                  </span>
                  <Calendar className="text-slate-500" size={20} />
                </div>

                {isOpen && (
                  <div className="absolute top-full left-0 mt-2 z-50">
                    <DateTimePicker
                      onSet={handleSet}
                      onCancel={handleCancel}
                      initialDate={finalDate}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Multi Select Widget Section */}
        <div className="flex-1 w-full flex flex-col items-center">
          {/* Removed overflow-hidden here */}
          <div className="bg-white rounded-xl shadow-md w-full max-w-md">
            <div className="p-6 border-b border-slate-100">
              <h2 className="text-xl font-semibold text-slate-700">Multi-Select Dropdown</h2>
            </div>
            <MultiSelectWidget />
          </div>
        </div>

      </div>

      {/* Chart Widget Section */}
      <div className="w-full max-w-6xl mt-8">
        <ChartWidget />
      </div>

      {/* Document Upload Widget Section */}
      <div className="w-full max-w-6xl mt-8">
        <DocumentUploadWidget />
      </div>

      {/* Firebase Notification Widget Section */}
      <div className="w-full max-w-6xl mt-8">
        <NotificationWidget />
      </div>

      {/* AI Image Widget Section */}
      <div className="w-full max-w-6xl mt-8 mb-10">
        <AIImageWidget />
      </div>

    </div>
  );
}

export default App;